import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppFab from "./components/WhatsAppFab";
import SmoothScroll from "./components/SmoothScroll";
import Home from "./pages/home/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import BulkOrders from "./pages/BulkOrders";
import Franchise from "./pages/Franchise";
import Contact from "./pages/Contact";
import Shops from "./pages/Shops";
import Preloader from "./components/Preloader";
import Tracker from "./components/Tracker";
import CookieConsent from "./components/CookieConsent";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { AuthProvider } from "./admin/AuthContext";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";

const PublicLayout = () => (
  <>
    <SmoothScroll />
    <Preloader />
    <Navbar />
    <main>
      <Outlet />
    </main>
    <Footer />
    <WhatsAppFab />
    <Tracker />
    <CookieConsent />
  </>
);

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/bulk-orders" element={<BulkOrders />} />
          <Route path="/dealer-franchise" element={<Franchise />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shops" element={<Shops />} />
          <Route path="/locations" element={<Shops />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<Home />} />
        </Route>
        <Route path="/admin/*" element={<AuthProvider><AdminRoutes /></AuthProvider>} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

const AdminRoutes = () => (
  <Routes>
    <Route path="login" element={<AdminLogin />} />
    <Route path="*" element={<AdminDashboard />} />
  </Routes>
);
